import * as Yup from 'yup';

export const initialValuesInsurancePolicyForm = {
    provider: null,
    policyNumber: '',
    groupNumber: '',
    contactPhone: '',
    contactEmail: '',
    contactAddress: '',
    contactCity: '',
    contactProvince: '',
    contactPostal: '',
    contactCountry: '',
    applyToAllFamilyMembers: false,
    status: 'active',
    notes: ''
};

export const insurancePolicyValidationSchema = Yup.object().shape({
    provider: Yup.object().nullable().required('Insurance provider is required'),
    policyNumber: Yup.string().required('Policy number is required'),
});
